/**
 * HR help text for the Assessment module.
 *
 * Probation is not just a record. When a probation request completes without
 * being extended, the system takes the employee off probation, which switches
 * them from probation leave quota to full quota and unlocks leave types that
 * disallow probation.
 */

const probation = {
  employment_id: "Employee being assessed. Their approval workflow decides who reviews the assessment.",
  end_date: "The date probation is due to finish. Completing the assessment on or after this date takes the employee off probation.",
  duration: "Length of probation in months. It sets how many evaluation periods are created.",
  month_wise_evaluation: "Evaluate the employee once per month across the probation period. Turn it off to record a single evaluation covering the whole period.",
  is_extended: "Extend probation instead of confirming the employee. While extended, the employee stays on probation quota and probation-restricted leave types remain blocked.",
  extended_duration: "How many extra months probation is extended by. Each extra month adds another evaluation period.",
  is_probation_completed: "Confirm the employee. This takes them off probation, so they move onto full leave quota and any probation restrictions are lifted.",
  reason: "Why probation is being extended or ended early. Approvers read this before deciding.",
  description: "Any note about this assessment.",
  remarks: "Remarks recorded with this evaluation step.",
  last_remarks: "Remarks written by the last reviewer. Visible in the assessment history.",
  message: "Message sent with this assessment.",
};

const evaluationScale = {
  name: "Name of this rating scale, such as Performance Scale, shown when someone is being scored.",
  short_name: "Short code used where the full name does not fit, such as tables and exported reports.",
  scale: "The highest score on this scale, for example 5 for a scale of one to five. Every evaluation using this scale is scored out of this number.",
  description: "Internal note explaining when this scale should be used.",
  is_active: "Only active scales can be selected for a new evaluation. Existing evaluations keep the scale they were scored on.",
};

const professionalAttribute = {
  name: "Name of the attribute being assessed, such as Punctuality or Teamwork. It appears as a row on the evaluation form.",
  short_name: "Short code used where the full name does not fit, such as tables and exported reports.",
  description: "Explains to reviewers what this attribute means, so different people score it consistently.",
  is_active: "Only active attributes appear on new evaluation forms. Existing evaluations keep the attributes they were scored on.",
};

export const assessmentTooltips = { probation, evaluationScale, professionalAttribute };
export default assessmentTooltips;
